export const BLOG_ARTICLE_STATUS = {
    deleted: 'DL',
    draft: 'DR',
    paused: 'PA',
    published: 'PB',
    scheduled: 'SC'
};
export const SITE_FILTER_NONE = 'none';
